import React, { useState, useMemo } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { Avatar } from "@fluentui/react-components";
import { MeBadge } from "../../../dashboard-util/dashboard-utils";
import PropTypes from "prop-types";
import {
  getLastUpdatedColor,
  renderLastUpdatedTooltipHeader,
  formatLastUpdatedDate,
  renderTooltipHeader,
  createColumnMenu,
} from "../../../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";

const TechBankerSummaryGrid = ({ summaryItem = {}, showDetails, onToggle }) => {
  const [summaryState, setSummaryState] = useState({ sort: [], filter: null });
  const gridData = useMemo(() => [summaryItem], [summaryItem]);
  const isAccordionDisabled = true; //Logic for accordion is developed- but disabling it as per product's request
  const columnMenu = createColumnMenu([summaryItem]);
  
  if (!summaryItem?.User) {
    return null;
  }
  
  return (
    <div className="summary-grid-wrapper">
      <Grid
        data={gridData}
        sort={summaryState.sort}
        filter={summaryState.filter}
        onSortChange={(e) => setSummaryState({ ...summaryState, sort: e.sort })}
        onFilterChange={(e) =>
          setSummaryState({ ...summaryState, filter: e.filter })
        }
        className="tech-banker-time-log-summary-grid"
      >
        <Column
          field="User.Name"
          title={renderTooltipHeader("Analyst/Associate")}
          width="330px"
          columnMenu={columnMenu}
          cell={(props) => {
            return (
              <td className="summary-cell k-table-td avatar-cell">
                <div className="avatar-content">
                  <Avatar name={summaryItem.User.Name} color="brand" size={32} />
                  <span>{summaryItem.User.Name}</span>
                  <MeBadge />
                </div>
              </td>
            );
          }}
        />
        <Column
          field="TotalLastWeekHours"
          title={renderTooltipHeader("Total Last Week Hours")}
          columnMenu={columnMenu}
        />
        <Column
          field="TotalWeekendHours"
          title={renderTooltipHeader("Total Weekend Hours")}
          columnMenu={columnMenu}
        />
        <Column
          field="AllDealsHours"
          title={renderTooltipHeader("Total Spent on all Deals")}
          columnMenu={columnMenu}
        />
        <Column
          field="TotalCurrentWeekHours"
          title={renderTooltipHeader("Total Current Week Hours")}
          columnMenu={columnMenu}
        />
        <Column
          field="LastUpdated"
          title={renderLastUpdatedTooltipHeader("Last Updated")}
          columnMenu={columnMenu}
          filter="date"
          cell={(props) => {
            const color = getLastUpdatedColor(props.dataItem.LastUpdated);
            const displayDate = formatLastUpdatedDate(props.dataItem.LastUpdated);

            return (
              <td className="summary-cell k-table-td">
                <span style={{ color }}>{displayDate}</span>
                <FluentButton
                  className="accordion-toggle-button"
                  disabled={true}
                  icon={
                    <FluentUiIcon
                      name={showDetails ? "ChevronUpRegular" : "ChevronDownRegular"}
                      size={16}
                      color={isAccordionDisabled ? "A0A0A0" : "#0F6CBD"}
                      disabled={isAccordionDisabled}
                    />
                  }
                  appearance="transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle();
                  }}
                />
              </td>
            );
          }}
        />
      </Grid>
    </div>
  );
};

export default TechBankerSummaryGrid;

TechBankerSummaryGrid.propTypes = {
  summaryItem: PropTypes.shape({
    User: PropTypes.shape({
      Name: PropTypes.string.isRequired
    }).isRequired,
    TotalLastWeekHours: PropTypes.number,
    TotalWeekendHours: PropTypes.number,
    AllDealsHours: PropTypes.number,
    TotalCurrentWeekHours: PropTypes.number,
    LastUpdated: PropTypes.string
  }).isRequired,
  showDetails: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};